<ng-multiselect-dropdown [placeholder]="'Horario(s)'" [settings]="dropdownSettings" [data]="dropdownList" appendTo="body"
    [(ngModel)]="selectedItems" (onSelect)="changeItems()" (onDeSelect)="changeItems()" (onSelectAll)="allItems($event)"
    (onDeSelectAll)="anyItems()">
</ng-multiselect-dropdown>